import { useParams } from 'react-router-dom'
import AccountCircle from '@mui/icons-material/AccountCircle'
import ListIcon from '@mui/icons-material/List'
import CircularProgress from '@mui/material/CircularProgress'
import { Box, Stack, Typography } from '@mui/material'
import PatientInfoHistory from './PatientInfoHistory'
import PatientHistoryTabs from './PatientHistoryTabs'
import sxs from './styles/PatientContainerHistoryStyles'
import { RouterRouteId } from '../../../routers/_props'
import { useGetIdsHealthcareservicesHcsIdPatientsPatientIdHistoryDetail } from '@toktokdoctech/tokapi-client'
import useCurrentHcs from '../../../hooks/useCurrentHcs'

const PatientContainerHistory = () => {
    const { id } = useParams<RouterRouteId>()
    const currentHcs = useCurrentHcs()

    const {
        data: patient,
        isLoading,
        isError,
    } = useGetIdsHealthcareservicesHcsIdPatientsPatientIdHistoryDetail(currentHcs.id, id ?? '')

    if (isError) {
        return null
    }

    return (
        <Stack width="100%" alignItems="center" gap="3rem">
            <Box width="100%">
                <Stack sx={sxs.PatientContainerHistorySectionLabel}>
                    <Stack sx={sxs.PatientContainerHistorySectionLabelIcon}>
                        <AccountCircle aria-label="avatar" />
                    </Stack>
                    <Typography sx={sxs.PatientContainerHistorySectionLabelText}>Informations patient</Typography>
                </Stack>
                {isLoading && <CircularProgress color="primary" />}
                {!isLoading && patient && <PatientInfoHistory patient={patient} />}
            </Box>
            <Box width="100%">
                <Stack sx={sxs.PatientContainerHistorySectionLabel}>
                    <Stack sx={sxs.PatientContainerHistorySectionLabelIcon}>
                        <ListIcon aria-label="historique" />
                    </Stack>
                    <Typography sx={sxs.PatientContainerHistorySectionLabelText}>Historique</Typography>
                </Stack>
                {isLoading && <CircularProgress color="primary" />}
                {!isLoading && patient && <PatientHistoryTabs patient={patient} />}
            </Box>
        </Stack>
    )
}

export default PatientContainerHistory
